module.exports = __webpack_public_path__ + "img/ft.ed20c935.png";